import type { AssistantConversationsListRow } from "@/admin/entities/assistant";
import type { AssistantConversationsListQueryType } from "@/types/graphql/admin.generated";

export function getTableData(data: unknown): {
  nodes: AssistantConversationsListRow[];
  count: number;
} {
  const conversations = (data as AssistantConversationsListQueryType)
    ?.assistantConversations;
  if (!conversations || !conversations.nodes) {
    return { nodes: [], count: 0 };
  }
  return conversations;
}

export function mapColumns(row: AssistantConversationsListRow) {
  return [
    row.id,
    row.audience,
    row,
    row,
    row,
    row.topic,
    row,
    row.knowledgeGap,
    row.hasRequest,
    row.costUsd,
    row.lastMessageAt,
  ];
}
